import { StyleSheet } from "react-native"
import { HeaderLeft, HeaderLeftOnNestedScreen } from "src/components/parts/headers/HeaderLeft"
import { Colors } from "src/constants/Colors"

const styles = StyleSheet.create({
  header: {
    backgroundColor: Colors.orange,
  },
  headerTitle: {
    color: Colors.white,
  },
})

export const commonOptions = {
  headerStyle: styles.header,
  headerTitleStyle: styles.headerTitle,
  headerTitleAlign: "center",
} as const

export const commonHeaderOptions = {
  ...commonOptions,
  headerLeft: HeaderLeft,
} as const

export const commonHeaderOptionsOnNestedScreen = {
  ...commonOptions,
  headerLeft: HeaderLeftOnNestedScreen,
} as const
